export default __webpack_public_path__ + "static/media/Rectangle 398.f616f50c.png";